import React, { useState, useEffect } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import GridItem from '../../Grid/GridItem.js';
import GridContainer from '../../Grid/GridContainer.js';
import CustomInput from '../../CustomInput/CustomInput.js';
import Button from '../../CustomButtons/Button.js';
import Card from '../../Card/Card.js';
import { connect } from 'react-redux';
import {
  getUserDetails as getUserList,
  saveNewAddress,
  updateUser as getUpdateUser
} from '../../../store/actions/user/User';
import CardHeader from '../../Card/CardHeader.js';
import CardBody from '../../Card/CardBody.js';
import CardFooter from '../../Card/CardFooter.js';
import Autocomplete from 'react-google-autocomplete';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);
var update = false;
function UserUpdate(props) {
  useEffect(() => {
    props.getUserList().then((data) => {
      if (data) {
        setUserState(props?.userDetails);
      }
    });
  }, [update]);
  const [newAddressOpen, updateNewAddressOpen] = useState(false);
  const [newAddress, updateNewAddress] = useState({});

  useEffect(() => {
    if (props?.userDetails) {
      const tempUserDetails = {
        userId: props?.userDetails?.id,
        lastName: props?.userDetails?.lastName,
        firstName: props?.userDetails?.firstName,
        DOB: props?.userDetails?.DOB,
        address: {
          building_number: props?.userDetails?.address?.building_number,
          street: props?.userDetails?.address?.street,
          city: props?.userDetails?.address?.city,
          state: props?.userDetails?.address?.state,
          country: props?.userDetails?.address?.country,
          pincode: props?.userDetails?.address?.pincode
        }
      };
      setUserState(tempUserDetails);
    }
  }, [props?.userDetails]);

  const [userState, setUserState] = React.useState({
    userId: localStorage.getItem('userId'),
    lastName: '',
    firstName: '',
    DOB: '',
    address: {
      building_number: '',
      street: '',
      city: '',
      state: '',
      country: '',
      pincode: ''
    }
  });

  const handleChange = (event) => {
    setUserState({ ...userState, [event.target.name]: event.target.value });
  };

  const handleDateChange = (value) => {
    const date = new Date(value);
    const month =
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const dob = `${date.getFullYear()}/${month}/${day}`;
    setUserState({ ...userState, DOB: dob });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    props.getUpdateUser(userState);
    props.history.push('/user');
  };

  const handleChangeAddress = (event) => {
    setUserState({
      ...userState,
      address: { ...userState.address, [event.target.id]: event.target.value }
    });
  };

  const handleNewAddressChange = (event) => {
    updateNewAddress({
      ...newAddress,
      [event.target.id]: event.target.value
    });
  };

  const onChangeNewAdress = (place) => {
    const userAddress = {
      city: '',
      state: '',
      street: '',
      country: '',
      pincode: '',
      latitude: place.geometry.location.lat().toString(),
      longitude: place.geometry.location.lng().toString()
    };
    for (var i = 0; i < place.address_components.length; i++) {
      for (var j = 0; j < place.address_components[i].types.length; j++) {
        if (place.address_components[i].types[j] === 'postal_code') {
          const pincode = place.address_components[i].long_name;
          userAddress.pincode = pincode;
        }
        if (
          place.address_components[i].types[j] === 'administrative_area_level_2'
        ) {
          const city = place.address_components[i].long_name;
          userAddress.city = city;
        }
        if (
          place.address_components[i].types[j] === 'administrative_area_level_1'
        ) {
          const state = place.address_components[i].long_name;
          userAddress.state = state;
        }
        if (place.address_components[i].types[j] === 'country') {
          const country = place.address_components[i].long_name;
          userAddress.country = country;
        }
        if (place.address_components[i].types[j] === 'route') {
          const area = place.address_components[i].long_name;
          userAddress.street = area;
        }
      }
    }
    const tempUserAddress = {
      ...newAddress,
      ...userAddress
    };
    updateNewAddress(tempUserAddress);
  };

  const onChangeAdress = (place) => {
    const userAddress = {
      city: '',
      state: '',
      street: '',
      country: '',
      pincode: ''
    };
    for (var i = 0; i < place.address_components.length; i++) {
      for (var j = 0; j < place.address_components[i].types.length; j++) {
        if (place.address_components[i].types[j] === 'postal_code') {
          const pincode = place.address_components[i].long_name;
          userAddress.pincode = pincode;
        }
        if (
          place.address_components[i].types[j] === 'administrative_area_level_2'
        ) {
          const city = place.address_components[i].long_name;
          userAddress.city = city;
        }
        if (
          place.address_components[i].types[j] === 'administrative_area_level_1'
        ) {
          const state = place.address_components[i].long_name;
          userAddress.state = state;
        }
        if (place.address_components[i].types[j] === 'country') {
          const country = place.address_components[i].long_name;
          userAddress.country = country;
        }
        if (place.address_components[i].types[j] === 'route') {
          const area = place.address_components[i].long_name;
          userAddress.street = area;
        }
      }
    }

    const tempuser = {
      ...userState,
      address: {
        ...userState?.address,
        ...userAddress
      }
    };
    setUserState(tempuser);
  };

  const addNewAddress = () => {
    props
      .saveNewAddress(newAddress)
      .then((data) => {
        if (data) {
          updateNewAddressOpen(!newAddressOpen);
        }
      })
      .catch((err) => {
        updateNewAddressOpen(!newAddressOpen);
      });
  };

  const classes = useStyles();
  return (
    <>
      {props.userDetails !== undefined && props.userDetails.length !== 0 ? (
        <Card>
          <CardHeader style={{ background: '#34BA92' }}>
            <h4 className={classes.cardTitleWhite}>Update your Profile</h4>
            <p className={classes.cardCategoryWhite}>Complete your profile</p>
          </CardHeader>
          <CardBody>
            <p
              style={{
                textAlign: 'left',
                paddingLeft: '9px',
                fontSize: '15px',
                fontWeight: 'bold',
                paddingRight: '9px',
                marginBottom: '-8px',
                paddingTop: '9px',
                color: '#00000090',
                borderRadius: '6px',
                paddingBottom: '9px',
                maxWidth: '170px',
                backgroundColor: '#34A9A230'
              }}
            >
              Basic informations
            </p>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="Firstname"
                  id="firstname"
                  name="firstName"
                  onChange={handleChange}
                  value={userState?.firstName}
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="Lastname"
                  id="lastName"
                  name="lastName"
                  onChange={handleChange}
                  value={userState?.lastName}
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    style={{ margin: '9px 0', width: '100%' }}
                    id="date-picker-dialog"
                    label="Date of Birthday"
                    format="yyyy/MM/dd"
                    name="DOB"
                    value={userState?.DOB}
                    onChange={handleDateChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    InputProps={{
                      fullWidth: true
                    }}
                  />
                </MuiPickersUtilsProvider>
              </GridItem>
            </GridContainer>
            <br />
            <p
              style={{
                textAlign: 'left',
                paddingLeft: '9px',
                fontSize: '15px',
                fontWeight: 'bold',
                paddingRight: '9px',
                paddingTop: '9px',
                color: '#00000090',
                borderRadius: '6px',
                paddingBottom: '9px',
                marginBottom: '-8px',
                width: '172px',
                backgroundColor: '#34A9A230'
              }}
            >
              Adress informations
            </p>
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={4}
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  marginBottom: '8px'
                }}
              >
                <Autocomplete
                  className="form-control"
                  onPlaceSelected={(place) => onChangeAdress(place)}
                  types={[]}
                  componentRestrictions={{ country: 'au' }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="Country"
                  id="country"
                  name="country"
                  onChange={handleChangeAddress}
                  value={userState?.address?.country}
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="State"
                  id="state"
                  name="state"
                  onChange={handleChangeAddress}
                  value={userState?.address?.state}
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="City"
                  id="city"
                  name="city"
                  onChange={handleChangeAddress}
                  value={userState?.address?.city}
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="Adress Building Number"
                  name="building_number"
                  onChange={handleChangeAddress}
                  value={userState?.address?.building_number}
                  id="building_number"
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="Pincode"
                  id="pincode"
                  name="pincode"
                  onChange={handleChangeAddress}
                  value={userState?.address?.pincode}
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <CustomInput
                  labelProps={{ shrink: true }}
                  labelText="Adress street"
                  id="street"
                  name="street"
                  onChange={handleChangeAddress}
                  value={userState?.address?.street}
                  formControlProps={{
                    fullWidth: true,
                    style: { marginTop: '10px' }
                  }}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
          <CardFooter style={{ padding: '0' }}>
            <Button style={{ background: '#34BA92' }} onClick={handleSubmit}>
              Update Profile
            </Button>
            <Button
              style={{ background: '#34BA92' }}
              onClick={() => updateNewAddressOpen(true)}
            >
              Add new Address
            </Button>
          </CardFooter>
          <Dialog
            onClose={addNewAddress}
            aria-labelledby="customized-dialog-title"
            open={newAddressOpen}
          >
            <DialogTitle id="customized-dialog-title" onClose={addNewAddress}>
              Add New Address
            </DialogTitle>
            <DialogContent dividers>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={12}
                  md={4}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    marginBottom: '8px'
                  }}
                >
                  <Autocomplete
                    className="form-control"
                    onPlaceSelected={(place) => onChangeNewAdress(place)}
                    types={[]}
                    componentRestrictions={{ country: 'au' }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelProps={{ shrink: true }}
                    labelText="Country"
                    id="country"
                    name="country"
                    onChange={handleNewAddressChange}
                    value={newAddress?.country}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: '10px' }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelProps={{ shrink: true }}
                    labelText="State"
                    id="state"
                    name="state"
                    onChange={handleNewAddressChange}
                    value={newAddress?.state}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: '10px' }
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelProps={{ shrink: true }}
                    labelText="City"
                    id="city"
                    name="city"
                    onChange={handleNewAddressChange}
                    value={newAddress?.city}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: '10px' }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelProps={{ shrink: true }}
                    labelText="Adress Building Number"
                    name="building_number"
                    onChange={handleNewAddressChange}
                    value={newAddress?.building_number}
                    id="building_number"
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: '10px' }
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelProps={{ shrink: true }}
                    labelText="Pincode"
                    id="pincode"
                    name="pincode"
                    onChange={handleNewAddressChange}
                    value={newAddress?.pincode}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: '10px' }
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelProps={{ shrink: true }}
                    labelText="Adress street"
                    id="street"
                    name="street"
                    onChange={handleNewAddressChange}
                    value={newAddress?.street}
                    formControlProps={{
                      fullWidth: true,
                      style: { marginTop: '10px' }
                    }}
                  />
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={addNewAddress} color="primary">
                Save changes
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      ) : (
        <>
          <img
            src="https://inolemit.sirv.com/utils/35%20(1).gif"
            style={{
              width: '100px',
              height: '100px',
              marginRight: 0,
              itemsAlign: 'center'
            }}
          />{' '}
          <br />{' '}
        </>
      )}
    </>
  );
}

const mapStateWithProps = (state) => ({
  userDetails: state.user.userDetails
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getUserList: () => dispatch(getUserList()),
    getUpdateUser: (data) => dispatch(getUpdateUser(data)),
    saveNewAddress: (data) => dispatch(saveNewAddress(data))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(UserUpdate);
